import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

// firebase init goes here 
const config = {
    apiKey: "AIzaSyBMflCgNs8eWJbluLlZtJoR2m6REKA5xwA",
    authDomain: "fpachd-it.firebaseapp.com",
    databaseURL: "https://fpachd-it.firebaseio.com",
    projectId: "fpachd-it",
    storageBucket: "fpachd-it.appspot.com",
    messagingSenderId: "895313651926",
    appId: "1:895313651926:web:39e1a025e83dbb15b14177"
  };

firebase.initializeApp(config) 

// firebase utils 
const db = firebase.firestore() 
const auth = firebase.auth() 
const storage  = firebase.storage()
//const currentUser = auth.currentUser 

// firebase collections 
const usersCollection = db.collection('users') 
//const uploadsCollection = db.collection('uploads')
const issuesCollection = db.collection('issues')
const issueFilesCollection = db.collection('issueFiles')
const issueMasterCollection = db.collection('issueMaster')
const issueTypesCollection = db.collection('issueTypes');
const issueSubtypesCollection = db.collection('issueSubtypes');
const brandsCollection = db.collection('brands');
const departmentsCollection = db.collection('departments');
const assigneesCollection = db.collection('assignees');
const solutionsCollection = db.collection('solutions');
const solutionTypesCollection = db.collection('solutionTypes');
const diagnosticsCollection = db.collection("diagnostics");
const diagnosticTypesCollection = db.collection('diagnosticTypes');
const locationsCollection = db.collection("locations")
const sectionsCollection = db.collection("sections");
const solutionMethodsCollection = db.collection("solutionMethods");
const issueStatusesCollection = db.collection('issueStatuses');
const problemSourcesCollection = db.collection('problemSources');
const accountablePersonsCollection = db.collection('accountablePersons');

//console.log("assigneesCollection",assigneesCollection)
export { 
     db, 
     auth, 
     storage,
     usersCollection,
     brandsCollection,
     departmentsCollection,
     issueMasterCollection,
     issueTypesCollection,
     issueSubtypesCollection,
     //uploadsCollection,
     issuesCollection,
     issueFilesCollection,
     assigneesCollection,
     solutionsCollection,
     solutionTypesCollection,
     diagnosticsCollection,
     diagnosticTypesCollection,
     locationsCollection,
     sectionsCollection,
     solutionMethodsCollection,
     issueStatusesCollection,
     problemSourcesCollection,
     accountablePersonsCollection
     //currentUser
}